import { render, staticRenderFns } from "./manageType.vue?vue&type=template&id=780d3934&scoped=true&lang=pug&"
import script from "./manageType.vue?vue&type=script&lang=js&"
export * from "./manageType.vue?vue&type=script&lang=js&"
import style0 from "./manageType.vue?vue&type=style&index=0&id=780d3934&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780d3934",
  null
  
)

export default component.exports